import { ApiUtility } from "../Utilities/ApiUtility.axios";

// Don't name the class the same as the file's export
class DailyPracticeStatsService {
    route = `/Api/DailyPracticeStats`;

    //getDailyPracticeStats = (params) => {
    //    // Construct a URLSearchParams object from the params object
    //    const queryParams = new URLSearchParams(params).toString();

    //    // Append the query string to the URL
    //    // The ternary operator ensures no '?' is added if there are no parameters
    //    return ApiUtility.get(`${this.route}/getpracticestats${queryParams ? `?${queryParams}` : ''}`);
    //};
getDailyPracticeStats = ({
  start = 0,
  length = 15,
  search = "",
  fromDate = "",
  toDate = "",
  sortCol = "",
  sortDir = "",
} = {}) => {
  return ApiUtility.get(
    `${this.route}/getpracticestats?start=${start}&length=${length}&search=${search}&fromDate=${fromDate}&toDate=${toDate}&sortCol=${sortCol}&sortDir=${sortDir}`
  );
};


}

// Export an instance
export default new DailyPracticeStatsService();
